import { useEffect } from 'react';
import isEmpty from 'lodash/fp/isEmpty';
import { useNavigate } from 'react-router-dom';
import { PATH, ERROR_CODES } from '#/guest-aps/config';
import amplitude from '#/guest-aps/services/amplitude';
import type { ParkingRecordBill } from '@autopass-web/types';

export const useAmplitudeSelectPlateNumberPageView = (
  parkingRecordBills: ParkingRecordBill[],
) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (isEmpty(parkingRecordBills))
      return navigate({
        pathname: PATH.ERROR,
        search: `?code${ERROR_CODES.NO_SESSION}`,
      });
    const isSupportAlpr = parkingRecordBills[0].store_is_support_alpr;
    amplitude.selectPlateNumberPageView(isSupportAlpr);
  }, [parkingRecordBills, navigate]);
};
